import {HSPPlacementStepModel} from './HSPPlacementStepModel';

export class HSPPlacementModel implements IHSPPlacementModel {
  /** Key for this template */
  id?: string | undefined;
  /** Created by */
  createdByUserId?: string | undefined;
  /** Title of the template */
  title!: string;
  /** Description of the template */
  description?: string | undefined;
  /** Optional company for specific placement processes */
  companyId?: string | undefined;
  /** Steps for this template */
  placementSteps!: HSPPlacementStepModel[];
  /** Default template */
  isDefault?: boolean | undefined;
  /** Disabled */
  isDisabled?: boolean | undefined;
  /** Date last updated */
  dateUpdated?: Date | undefined;

  constructor(data?: IHSPPlacementModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.placementSteps = [];
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.createdByUserId = Data["createdByUserId"];
      this.title = Data["title"];
      this.description = Data["description"];
      this.companyId = Data["companyId"];
      if (Array.isArray(Data["placementSteps"])) {
        this.placementSteps = [] as any;
        for (let item of Data["placementSteps"])
          this.placementSteps!.push(HSPPlacementStepModel.fromJS(item));
      }
      this.isDefault = Data["isDefault"];
      this.isDisabled = Data["isDisabled"];
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): HSPPlacementModel {
    data = typeof data === 'object' ? data : {};
    let result = new HSPPlacementModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["createdByUserId"] = this.createdByUserId;
    data["title"] = this.title;
    data["description"] = this.description;
    data["companyId"] = this.companyId;
    if (Array.isArray(this.placementSteps)) {
      data["placementSteps"] = [];
      for (let item of this.placementSteps)
        data["placementSteps"].push(item.toJSON());
    }
    data["isDefault"] = this.isDefault;
    data["isDisabled"] = this.isDisabled;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    return data;
  }
}

export interface IHSPPlacementModel {
  /** Key for this template */
  id?: string | undefined;
  /** Created by */
  createdByUserId?: string | undefined;
  /** Title of the template */
  title: string;
  /** Description of the template */
  description?: string | undefined;
  /** Optional company for specific placement processes */
  companyId?: string | undefined;
  /** Steps for this template */
  placementSteps: HSPPlacementStepModel[];
  /** Default template */
  isDefault?: boolean | undefined;
  /** Disabled */
  isDisabled?: boolean | undefined;
  /** Date last updated */
  dateUpdated?: Date | undefined;
}